export * from '@fhs/routing/src/routes/(drawer)/support/form';
export { default } from '@fhs/routing/src/routes/(drawer)/support/form';
